/* PV sticky add to cart (W4).
   Submits the REAL main product form through the button's `form` attribute, so Dawn's
   product-form.js handles the AJAX add, cart drawer, errors, variant and quantity. */
if (!customElements.get('pv-sticky-atc')) {
  customElements.define(
    'pv-sticky-atc',
    class PvStickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-pv-sticky-submit]');
        this.labelEl = this.querySelector('[data-pv-sticky-label]');
        this.priceEl = this.querySelector('[data-pv-sticky-price]');
        this.compareEl = this.querySelector('[data-pv-sticky-compare]');
        this.variantEl = this.querySelector('[data-pv-sticky-variant]');
        this.unsubscribers = [];
        try {
          this.variants = JSON.parse(this.querySelector('[data-pv-sticky-variants]').textContent);
        } catch (e) {
          this.variants = {};
        }

        this.form =
          document.getElementById(this.dataset.formId) ||
          document.querySelector('product-info form[data-type="add-to-cart-form"]');
        if (!this.form || !this.button) return;
        if (this.form.id) this.button.setAttribute('form', this.form.id);
        if (this.classList.contains('pv-sticky-atc--desktop')) {
          document.body.classList.add('pv-sticky-atc-desktop');
        }

        this.observeMainButtons();
        this.listenForVariants();
        this.listenForCart();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.unsubscribers.forEach((unsubscribe) => unsubscribe());
        if (this.onChange) document.removeEventListener('change', this.onChange);
        document.body.classList.remove('pv-sticky-atc-open', 'pv-sticky-atc-desktop');
      }

      observeMainButtons() {
        if (!('IntersectionObserver' in window)) return;
        const target = this.form.querySelector('.product-form__buttons') || this.form;
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            // Show only once the main buttons are ABOVE the viewport (scrolled past), not before.
            this.toggle(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
          });
        });
        this.observer.observe(target);
      }

      toggle(show) {
        if (show === this.visible) return;
        this.visible = show;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        this.toggleAttribute('inert', !show);
        if (show) {
          document.body.style.setProperty('--pv-sticky-atc-height', this.offsetHeight + 'px');
        }
        document.body.classList.toggle('pv-sticky-atc-open', show);
      }

      listenForVariants() {
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsubscribers.push(
            subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const variant = event && event.data && event.data.variant;
              this.update(variant ? variant.id : null);
            })
          );
        }
        this.onChange = (event) => {
          const target = event.target;
          if (target && target.name === 'id' && target.form === this.form) this.update(target.value);
        };
        document.addEventListener('change', this.onChange);
      }

      update(variantId) {
        const data = variantId ? this.variants[String(variantId)] : null;
        if (!data) {
          // Unavailable option combination: Dawn disables its own button the same way.
          this.setAvailable(false, this.dataset.soldOut);
          return;
        }
        if (this.priceEl) this.priceEl.textContent = data.price;
        if (this.compareEl) this.compareEl.textContent = data.compare || '';
        if (this.variantEl) this.variantEl.textContent = data.title;
        this.setAvailable(data.available, data.available ? this.dataset.label : this.dataset.soldOut);
      }

      setAvailable(available, label) {
        this.button.disabled = !available;
        if (this.labelEl && label) this.labelEl.textContent = label;
      }

      listenForCart() {
        const done = () => this.button.removeAttribute('aria-busy');
        this.button.addEventListener('click', () => {
          if (this.button.disabled) return;
          this.button.setAttribute('aria-busy', 'true');
          // Safety net in case no cart event arrives.
          setTimeout(done, 4000);
        });
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.cartUpdate, done));
          this.unsubscribers.push(
            subscribe(PUB_SUB_EVENTS.cartError, () => {
              if (this.button.getAttribute('aria-busy') !== 'true') return;
              done();
              // Dawn prints the error next to the main button; bring it into view.
              const productForm = this.form.closest('product-form');
              if (productForm) productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
            })
          );
        }
      }
    }
  );
}
